import { getAxiosCached } from '@/helpers/axios-helper';

export interface StaticPage {
	attributes: { menu: string; menu_v2: string; sorting: string; platform?: string };
	full_path: string;
	id: number;
	technical_name: string;
	translation: string;
}

export type StaticRequestOptions = {
	attribute_key: string;
	attribute_value: number;
	language: string;
};

const defaultOptions: Partial<StaticRequestOptions> = {
	attribute_key: 'menu_v2',
	attribute_value: 1,
};

export const StaticPageHelper = {
	/**
	 * fetch static content from api with options of type StaticRequestOptions
	 *
	 * @param {string} locale website locale
	 * @param {Partial<StaticRequestOptions>} options params for api call
	 *
	 * @return Promise<StaticPage[]
	 */
	async fetchPages(locale: string, options?: Partial<StaticRequestOptions>): Promise<StaticPage[]> {
		const url = `${JW_CONFIG.API}/pages/locale/${locale}`;

		const params = { ...defaultOptions, ...options };

		const result = await getAxiosCached().get<{ items: StaticPage[] }>(url, { params });
		return result.data.items.sort(
			(a: any, b: any) => parseInt(a.attributes.sorting, 10) - parseInt(b.attributes.sorting, 10)
		);
	},
};
